import { createContext, useEffect, useReducer, useRef } from 'react';

import Component from '../../types/Component';
import PlaceType from '../../types/Place';

import placeReducer from './reducer';
import { PlaceDispatcher } from './types';

export const PlaceProviderContext = createContext({
	state: {} as PlaceType | null,
	dispatch: {} as PlaceDispatcher,
	loadError: null as string | null,
});

const PlaceProvider: Component<{ initialState: PlaceType; error: string | null }> = ({
	initialState,
	error,
	children,
}) => {
	const [state, dispatch] = useReducer(placeReducer, initialState);
	const isInitializedRef = useRef<boolean>(false);

	useEffect(() => {
		if (isInitializedRef.current) {
			dispatch({ type: 'update-place', place: initialState });
		}
		isInitializedRef.current = true;
	}, [initialState]);

	return (
		<PlaceProviderContext.Provider value={{ state, dispatch, loadError: error }}>
			{children}
		</PlaceProviderContext.Provider>
	);
};

export default PlaceProvider;
